import {
  FooterContainer,
  StepTitle,
  WizardContentWrapper,
  FooterSkipButton,
  StyledStepTitleWrapper,
} from "@/components/onboarding/components/welcome-wizard/onboarding-steps.styles";
import type { ImportStepProps } from "./import-types";
import { MDSIconButton, MDSText, MDSTextVariant, MDSTextWeight, MDSIconKind, MDSIcon } from "@/mds";
import { getFilteredNotesApps } from "./import-steps.config";
import { StepContentWithTabs } from "./tabs";
import {
  AppDownloadButton,
  AppIconWrapper,
} from "@/components/onboarding/components/app-download-button";
import { navigateToExternalWindowUrl } from "@/modules/window/navigation";
import { APP_CONFIG } from "@/domains/global/config";

// New one-click import step for web (feature flag enabled)
export const AppleNotesOneClickStepWeb: React.FC<ImportStepProps> = ({
  context,
  handleTabSelect,
  onSkip,
  onClose,
}) => {
  const handleDownload = async () => {
    await navigateToExternalWindowUrl({ url: new URL(APP_CONFIG.URLS.MAC_APP_ONBOARDING) });
  };

  return (
    <WizardContentWrapper>
      <StyledStepTitleWrapper>
        <StepTitle>Import Notes</StepTitle>
        {context.placement === "profile-menu" && (
          <MDSIconButton iconKind={MDSIconKind.Exit} onClick={onClose} />
        )}
      </StyledStepTitleWrapper>
      <StepContentWithTabs
        selectedAppId={context?.selectedAppId || null}
        onAppSelect={handleTabSelect}
        tabConfig={{ tabs: getFilteredNotesApps() }}
      >
        <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
          To import from Apple Notes in one click, install the Mem desktop app
        </MDSText>
        <AppDownloadButton onClick={handleDownload}>
          <AppIconWrapper isApple>
            <MDSIcon kind={MDSIconKind.BrandApple} size={16} />
          </AppIconWrapper>
          <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
            Download Mac app
          </MDSText>
        </AppDownloadButton>
      </StepContentWithTabs>
      {onSkip && (
        <FooterContainer align="space-between">
          <FooterSkipButton onClick={onSkip} isDisabled={!onSkip}>
            Skip for now
          </FooterSkipButton>
        </FooterContainer>
      )}
    </WizardContentWrapper>
  );
};
